import { KngBannerState } from '../../banner';
import { KngButtonState } from '../../button';
import { KngContentState } from '../../content';
import { KngFooterState } from '../../footer/definitions';
import { KngHeaderNavStateItem } from '../../nav/header-nav/definitions';

export interface KngShell {
  state: KngShellState | null;
}
export interface KngShellState {
  header: Array<KngHeaderNavStateItem>;
  banner: KngBannerState;
  content: KngContentState;
  footer: KngFooterState;
  changeLanguageButton: KngButtonState;
  isMyInSights?: boolean;
}

export interface KngCustomerState {
  hidden: boolean;
  warningNote: string;
  readOnly: string;
  endSession: string;
  username: string;
}
